/**
 * cross section overlay for 3d
 */
import _ from "underscore";
import µ from "../../earth/1.0.0/micro";
import products from "../../earth/1.0.0/products";
import mcMapProjection from "./mc-map-projection"
import mcGeometry from "./mc-geometry"
import mcText from "./mc-overlay-text"
import * as THREE from "three";

export default (function (scene, radius) {
    var overlayGeometry, overlayMaterial, overlayMesh;
    var pressureLineGeometry, pressureLineMaterial, pressureLineMesh;
    const overlayMeshName = "cs3dOverlayMesh";
    const pressureLineName = "cs3dPressureLineName";

    var pressureLabel;

    function menshOverlayMaterial(crossSectionData, scale, binaryScale){
        overlayGeometry = mcGeometry.crossSectionGeometry(crossSectionData.coords, crossSectionData.data, crossSectionData.pressures, radius, scale, binaryScale, mcMapProjection.orthographic);
        overlayMaterial = new THREE.MeshBasicMaterial({
			transparent: true, 
			wireframe: false, 
            opacity: 0.8,
            side: THREE.DoubleSide,
            vertexColors: THREE.VertexColors,
		});

        overlayMesh = new THREE.Mesh(overlayGeometry, overlayMaterial);
        overlayMesh.name = overlayMeshName;
        scene.add(overlayMesh);
        // crossSectionData = null;
        // quickRender();
    }

    function meshPressureLineMaterial(crossSectionData){
		pressureLineGeometry = mcGeometry.crossSectionPressureLineGeometry(crossSectionData.coords, crossSectionData.data, crossSectionData.pressures, radius, mcMapProjection.orthographic);
		pressureLineMaterial = new THREE.LineDashedMaterial( {
			color: 0xE0E0E0,
			linewidth: 1,
			scale: 1,
			dashSize: 3,
			gapSize: 1,
		} );

        pressureLineMesh = new THREE.LineSegments(pressureLineGeometry, pressureLineMaterial);
        pressureLineMesh.name = pressureLineName;
		pressureLineMesh.computeLineDistances();

		scene.add(pressureLineMesh);
    }
    
    function meshPressureLabel(crossSectionData, quickRender){
		let positions = mcGeometry.crossSectionPressureLabelPositions(crossSectionData.coords, crossSectionData.data, crossSectionData.pressures, radius, mcMapProjection.orthographic);
		let textInfos = [];
		let ix = 0;

		crossSectionData.pressures.forEach(function(pressure){
			textInfos.push({
				text: pressure + " hPa",
				position: positions[ix++]
			});
        });

        // pressureLabel = mcText(scene, 0);
		// pressureLabel.render(textInfos, quickRender);
	}

    function clear(){
        if(overlayMesh) scene.remove(scene.getObjectByName(overlayMeshName));
        if(pressureLineMesh) scene.remove(scene.getObjectByName(pressureLineName));

		if(overlayGeometry) overlayGeometry.dispose();
		if(overlayMaterial) {
			overlayMaterial.dispose();
        }
        
        overlayGeometry = undefined;
		overlayMaterial = undefined;
        overlayMesh = undefined;
        
        if(pressureLineGeometry) pressureLineGeometry.dispose();
		if(pressureLineMaterial) pressureLineMaterial.dispose();

		pressureLineGeometry = undefined;
		pressureLineMaterial = undefined;
        pressureLineMesh = undefined;

        if(pressureLabel) pressureLabel.clear();
        pressureLabel = undefined;
	}

    function render(crossSectionData, scale, binaryScale, quickRender){
        menshOverlayMaterial(crossSectionData, scale, binaryScale);
        meshPressureLineMaterial(crossSectionData);
        // meshPressureLabel(crossSectionData, quickRender);
        quickRender();
    }

    function name(){
        return overlayMeshName;
    }

    function moveOverlay(rotate, scale) {
        if (overlayMesh && pressureLineMesh) {
            // roate
            var twoPI = Math.PI * 2;
            var halfPI = Math.PI / 2;
            pressureLineMesh.rotation.y = overlayMesh.rotation.y = Math.PI + halfPI + (rotate[0] / 360 * twoPI) + (-0.35 * Math.PI / 180);
            pressureLineMesh.rotation.x = overlayMesh.rotation.x = -rotate[1] / 90 * Math.PI / 2;
            pressureLineMesh.rotation.z = overlayMesh.rotation.z = rotate[2] / 360 * twoPI;

            // zoom
            overlayMesh.scale.set(scale, scale, scale);
            pressureLineMesh.scale.set(scale, scale, scale);
        }
    }

    return {
        render: render,
        clear: clear,
        name: name,
        moveOverlay: moveOverlay,
    };

});